import api from './api';

export const analyticsService = {
    async getDepartmentAnalytics(department, params = {}) {
        const response = await api.get(`/analytics/department/${department}`, {
            params,
        });
        return response.data;
    },

    async getProgramAnalytics(programType, params = {}) {
        const response = await api.get(`/analytics/program/${programType}`, {
            params,
        });
        return response.data;
    },

    async getCoverageAnalytics(params = {}) {
        const response = await api.get('/analytics/coverage', { params });
        return response.data;
    },

    async getTrends() {
        const response = await api.get('/analytics/trends');
        return response.data;
    },

    async getOutcomes(term) {
        const response = await api.get('/analytics/outcomes', {
            params: { term },
        });
        return response.data;
    },

    async getConversion(term) {
        const response = await api.get('/analytics/conversion', {
            params: { term },
        });
        return response.data;
    },

    async getDistribution(term) {
        const response = await api.get('/analytics/distribution', {
            params: { term },
        });
        return response.data;
    },

    async getSatisfaction(term) {
        const response = await api.get('/analytics/satisfaction', {
            params: { term },
        });
        return response.data;
    },
};

export default analyticsService;
